import { AddressField, Field } from '../declarations/widget-ums';

export const EMPTY_FIELD: Field = {
  value: '',
  disabled: false,
  error: false,
};

export const EMPTY_ADDRESS_FIELD: AddressField = {
  value: {
    text: '',
  },
  error: false,
};
